import { render, staticRenderFns } from "./DialogWindow.vue?vue&type=template&id=0882d8ff&scoped=true"
import script from "./DialogWindow.vue?vue&type=script&lang=js"
export * from "./DialogWindow.vue?vue&type=script&lang=js"
import style0 from "./DialogWindow.vue?vue&type=style&index=0&id=0882d8ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0882d8ff",
  null
  
)

export default component.exports